<template>
  <div>
    <menu-top/>


    <v-main>
      <div id="calculadora-itp">
        <section>
          <v-container>
            <v-row justify="center">
              <v-col cols="12" md="10">
                <h1 class="mt-10 mb-3">Calcular el precio de la transferencia (ITP)</h1>
                <p class="mb-8 intro-itp">
                  Calcula al instante el coste de la transferencia de un coche o moto de
                  segunda mano: Impuesto de Transmisiones Patrimoniales (ITP) más la tasa
                  de la DGT. En Gestoría Riola confirmamos el cálculo y tramitamos el
                  cambio de titularidad completo por ti.
                </p>

                <calculadora-itp
                  :formspree-endpoint="'https://formspree.io/f/mlgqpqkw'"
                  idioma="es"
                />
              </v-col>
            </v-row>
          </v-container>
        </section>

        <Footer/>
      </div>
    </v-main>

    <menu-bottom/>
  </div>
</template>

<script>
  import MenuTop from "@/components/MenuTopEsp";
  import MenuBottom from "@/components/MenuBottomEsp";
  import { mapGetters } from 'vuex';

  import Footer from "@/components/FooterEsp";
  import CalculadoraItp from "@/components/CalculadoraItp";

  export default {
    name: 'PageCalculadoraItpEsp',
    data: () => ({
    }),
    computed: {
      ...mapGetters(['collapseSidebar']),
    },
    methods: {
    },
    components: {
      Footer,
      MenuTop,
      MenuBottom,
      CalculadoraItp
    }
  }
</script>

<style scoped>
  .intro-itp {
    color: #37454A;
    max-width: 760px;
  }
  #calculadora-itp h1 {
    color: #900A30;
  }
</style>
